export class ResponseError {
    errorCode: number;
    message: string;
    errorMessages: Array<any>;
    constructor(errObj: any) {
        Object.assign(this, errObj);
    }
}